import React from 'react';
import PropTypes from 'prop-types';
import BaseComp from '../BaseComponent';
import Fragment from '../Fragment';

/**
 * @return {null}
 */
export default function If({ as = Fragment, condition, ...rest }) {
  return condition ? <BaseComp as={as} {...rest} /> : null;
}

If.propTypes = {
  children: PropTypes.node,
  condition: PropTypes.bool,
};
